import script from "./PdSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./PdSpinner.vue?vue&type=script&setup=true&lang=js"

import "./PdSpinner.vue?vue&type=style&index=0&id=425151f0&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425151f0"]])

export default __exports__